import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ScheduleTask } from '../../../../models/scheduleTask';
import { Chamber, Exhibit, ScheduleTasksService } from '../../../..';
import { Device } from '../../../../models/device';
import { ExhibitsViewComponent } from '../../../pages/devices/exhibits-view/exhibits-view.component';
import { DeviceViewComponent } from '../../../pages/devices/device-view/device-view.component';
import { ChambersViewComponent } from '../../../pages/devices/chambers-view/chambers-view.component';
import { AlertService, MessageType } from '../../../../services/alert.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { DevicesService } from '../../../../api/api';

@Component({
  selector: 'app-edit-schedule-task-dialog',
  templateUrl: './edit-schedule-task-dialog.component.html',
  styleUrls: ['./edit-schedule-task-dialog.component.scss']
})
export class EditScheduleTaskDialogComponent implements OnInit {
  scheduleTask: ScheduleTask = new ScheduleTask();

  loading = true;

  selectedChambers: Chamber[];
  selectedExhibits: Exhibit[];
  selectedDevices: Device[];

  @ViewChild('exhibits', {static: false}) exhibitsTable: ExhibitsViewComponent;
  @ViewChild('devices', {static: false}) devicesTable: DeviceViewComponent;
  @ViewChild('chambers', {static: false}) chambersTable: ChambersViewComponent;

  constructor(
    private scheduleTasksService: ScheduleTasksService,
    private devicesService: DevicesService,
    private alertService: AlertService,
    public dialog: MatDialogRef<EditScheduleTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
    this.scheduleTasksService.get(this.data.model.id).subscribe(result => {

      this.scheduleTask = new ScheduleTask(result);
      this.selectedDevices = this.scheduleTask.devices;
      this.loading = false;
    });

  }

  setSelectedChambers($event) {
    this.selectedChambers = $event.selection.selected;
    this.selectedChambers.forEach(chamber => {
      this.exhibitsTable.dataSource.data.forEach((row: Exhibit) => {
        if (row.chamberId === chamber.id) {
          this.exhibitsTable.selection.select(row);
        }
      });
    });
  }

  setSelectedExhibits($event) {
    this.selectedExhibits = $event.selection.selected;
    this.selectedExhibits.forEach(exhibit => {
      this.devicesTable.dataSource.data.forEach((row: Device) => {
        if (row.exhibit.id === exhibit.id) {
          this.devicesTable.selection.select(row);
        }
      });
    });
  }

  setSelectedDevices($event) {
    this.selectedDevices = $event.selection.selected;
    this.scheduleTask.devices = this.selectedDevices;
  }

  editScheduleTask() {
    this.scheduleTasksService
    .update(this.scheduleTask.id, this.scheduleTask)
    .pipe(map(scheduleTaskDto => new ScheduleTask(scheduleTaskDto)))
    .subscribe((next) => {
      this.alertService.showMessage('Pomyślnie zmodyfikowano wydarzenie harmonogramu', MessageType.Info);
      this.scheduleTask = next;
      this.dialog.close(true);
    },
    (error) => {
      this.alertService.showMessage('Błąd podczas tworzenia wydarzenia harmonogramu: ' + error.error, MessageType.Info);
    });
  }

}
